import React, { useEffect, useState } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { StyledContainer } from "../../../globalStyle/GlobalStyle";
import { ParametersWrapper } from "../Parameters.styled";
import { FormContainer, StyledForm } from "../../../components/Form/FormComponents.styled";
import { InputField, SelectField } from "../../../components/Form/FormComponents";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import { Link, useNavigate, useParams } from "react-router-dom";
import { deleteParameter, fetchParameterById, updateParameter } from "../utils";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const EditParameter = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [formData, setFormData] = useState({});
	const [loading, setLoading] = useState(false);
	const variablesOptions = useSelector((state) => state.parameters.variables);

	useEffect(() => {
		setLoading(true);
		getParameter();
	}, []);

	const getParameter = async () => {
		const data = await fetchParameterById(id);
		if (data && !data.error) {
			setFormData(data);
			setLoading(false);
		} else {
			toast.error("Error fetching parameter!");
		}
	};

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);
		console.log(formData);

		const data = updateParameter(formData);
		if (data && !data.error) {
			console.log(data);
			setLoading(false);
			toast.success("Parameter updated successfully!");
			navigate("/parameters");
		} else {
			setLoading(false);
			toast.error("Error updating parameter!");
		}
	};

	const handleDelete = () => {
		let res = deleteParameter(id);
		res.then((data) => {
			if (data && !data.error) {
				toast.success("Parameter deleted successfully!");
				navigate("/parameters");
			} else {
				toast.error("Error deleting parameter!");
			}
		});
	};

	return (
		<AdminDashboardLayout>
			<StyledContainer>
				<ParametersWrapper>
					<Link
						to='/parameters'
						style={{ color: "#408D94", width: "fit-content", marginBottom: "2.25rem" }}
						className='flex gap-2 border '>
						<BiArrowBack size={24} />
						<p>Go back</p>
					</Link>

					<FormContainer>
						<StyledForm onSubmit={handleSubmit}>
							<div className='parametersList w-full'>
								<div className='grid grid-cols-4 gap-3'>
									<div className='heading'>Parameters</div>
									<div className='heading'>Value</div>
									<div className='heading'>Period</div>
									<div className='heading'>Terms</div>
								</div>

								<div className='grid grid-cols-4 gap-3'>
									<div className='listItem'>
										<InputField
											name={"parameter"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											placeholder='Enter parameter name'
											value={formData?.parameter}
										/>
									</div>

									<div className='listItem'>
										<InputField
											name={"value"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											placeholder='Enter value'
											value={formData?.value}
										/>
									</div>

									<div className='listItem'>
										<SelectField
											name={"period"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											value={formData?.period}
											options={variablesOptions.period}
										/>
									</div>

									<div className='listItem'>
										<SelectField
											name={"term"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											value={formData?.term}
											options={variablesOptions.terms}
										/>
									</div>
								</div>

								<div className='actions flex mt-7' style={{}}>
									<Button variant='contained' type='submit'>
										Save
									</Button>

									<Button variant='outlined' onClick={handleDelete} style={{ marginLeft: "1rem" }}>
										Delete
									</Button>
								</div>
							</div>
						</StyledForm>
					</FormContainer>
				</ParametersWrapper>
			</StyledContainer>

			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
};

export default EditParameter;
